import React from 'react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { DateField } from '../../../ui/DateField';
import { parseIsoDate, toIsoDate } from '../../../../lib/iso-date';

interface DateInputFormProps {
  name: string | undefined | any;
  label: string | undefined;
  placeholderText?: string;
  isRequired?: boolean;
  disabled?: boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
  control: any;
  errors: any;
}

export const DateInputForm = ({
  name,
  label,
  placeholderText,
  isRequired = false,
  disabled = false,
  minDate,
  maxDate,
  errors,
  control,
}: DateInputFormProps) => (
  <FormControl isRequired={isRequired} isInvalid={!!errors[name]}>
    <FormLabel htmlFor={name}>{label}</FormLabel>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DateField
          id={name}
          label={label}
          placeholder={placeholderText || 'dd/mm/aaaa'}
          isDisabled={disabled}
          isInvalid={!!errors[name]}
          value={field.value instanceof Date ? toIsoDate(field.value) : field.value || ''}
          onChange={(iso) => field.onChange(iso ? parseIsoDate(iso) ?? null : null)}
          {...(minDate ? { fromDate: minDate } : {})}
          {...(maxDate ? { toDate: maxDate } : {})}
          yearsBefore={80}
          yearsAfter={5}
        />
      )}
    />
    {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
  </FormControl>
);
